import { useCallback, useMemo } from 'react';
import useMarketInput from 'hooks/market/useMarketInput';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from 'utils/constants';
import { RefetchType } from 'generated/graphql';

const useMarketPagination = () => {
  const { marketInput, onInputChange } = useMarketInput();

  const pageNumber = useMemo(
    () => marketInput?.paginationOption?.pageNumber ?? DEFAULT_PAGE_NUMBER,
    [marketInput.paginationOption?.pageNumber],
  );

  const handleOnPageChange = useCallback(
    (newPageNumber: number) => {
      if (newPageNumber === pageNumber) {
        return;
      }

      onInputChange({
        paginationOption: {
          pageNumber: newPageNumber,
          pageSize: DEFAULT_PAGE_SIZE,
          ids: [],
          type: RefetchType.Unknown,
        },
      });
    },
    [pageNumber, onInputChange],
  );

  const handleOnPageIncrease = useCallback(
    (hasNextPage?: boolean) => {
      if (!hasNextPage) return;
      handleOnPageChange(pageNumber + 1);
    },
    [handleOnPageChange, pageNumber],
  );

  const handleResetPageNumber = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    onInputChange({
      paginationOption: {
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        ids: [],
        type: RefetchType.Unknown,
      },
    });
  }, [onInputChange]);

  return { pageNumber, onIncreasePage: handleOnPageIncrease, onResetPagination: handleResetPageNumber };
};

export default useMarketPagination;
